export const isProd = process.env.NODE_ENV === 'production'
export const API_URL = isProd ? 'https://api.prodmake.com' : 'http://localhost:5006'
export const WS_URL = isProd ? 'wss://sync.prodmake.com' : 'ws://localhost:5050'
export const STRIPE_PUBLISHABLE_KEY =
  isProd
    ? 'pk_live_51NkbLxKVtvstMTQ1CHfMMIjpsv4tUsZgmAqziyAIkb6SubuVyeKQ7p1NWKWFrpplpN8pQcQbqtfLtcVBuevpcZmH006NNOyyLo'
    : 'pk_test_51NkbLxKVtvstMTQ16eH3cuNF0fJfp9D8Z6XqQnGdOGYkECo0Q1ghoIbP50gYHLJNJ4W7kNeOK8OlUrJgaaTkKPK900Di9PMzNP'
